import INApi from './_inApi.js';
import httpClient from '@/apis/base/httpclient';

class ReArrangeInventoryAPI extends INApi {
    constructor() {
        super();
    }
    controllerName = 'reArrangeInventorys';


    saveReArrangeInventory(payload) {
        let request = {
            url: this.getAPIUrl() + '/SaveReArrangeInventory',
            data: payload,
        };

        return httpClient.postAsync(request);
    }
}
export default new ReArrangeInventoryAPI();
